import { useEffect, useState, useRef } from 'react';
import { getHospitalItem } from 'utility/general';
import { getTimeWithTimeZone } from 'utility/general';
import { useSelector, useDispatch } from 'react-redux';
import { SET_DECLARATION_AND_ENDORSEMENT } from 'store/key';
// import usePrevious from 'hooks/usePrevious';
// import { isEqual } from 'lodash';

const useDeclarationAndEndorsementData = (props) => {
    const {
        applicationDetail,
        siteInfoId,
        removeRequestCoiIds,
        // formId,
    } = props;
    const declareStudentList = applicationDetail.declareStudent ?? [];
    const declareList = applicationDetail.declare ?? [];
    const declareInvList = applicationDetail.declareInv ?? [];

    const dispatch = useDispatch();
    const declarationAndEndorsement = useSelector((state) => state.declarationAndEndorsement);

    let {
        declareStudentRows,
        declareInvRows,
        HAEndorsementRows,
        universitiesEndorsementRows,
        HAUniversitiesEndorsementRows,
    } = declarationAndEndorsement;

    /** map each site/study rows data */
    const mapRows = (rows) => {
        let newRows = [];
        rows?.forEach((item) => {
            if (item.siteInfo?.id === siteInfoId) {
                newRows.push(item);
            }
        });
        return newRows;
    };

    const [newDeclareStudentRows, setNewDeclareStudentRows] = useState([]); // useState(declareStudentRows.length ? mapRows(declareStudentRows) : []);
    const [newDeclareInvRows, setNewDeclareInvRows] = useState([]); //useState(declareInvRows.length ? mapRows(declareInvRows) : []);
    const [newHAEndorsementRows, setNewHAEndorsementRows] = useState([]);
    const [newUniversitiesEndorsementRows, setNewUniversitiesEndorsementRows] = useState([]);
    const [newHAUniversitiesEndorsementRows, setNewHAUniversitiesEndorsementRows] = useState([]);

    useEffect(() => {
        if (!declareStudentRows.length && !newDeclareStudentRows.length) return;
        setNewDeclareStudentRows(mapRows(declareStudentRows));
        // eslint-disable-next-line
    }, [declareStudentRows]);
    useEffect(() => {
        if (!declareInvRows.length && !newDeclareInvRows.length) return;
        setNewDeclareInvRows(mapRows(declareInvRows));
        // eslint-disable-next-line
    }, [declareInvRows]);
    useEffect(() => {
        if (!HAEndorsementRows.length && !newHAEndorsementRows.length) return;
        setNewHAEndorsementRows(mapRows(HAEndorsementRows));
        // eslint-disable-next-line
    }, [HAEndorsementRows]);
    useEffect(() => {
        if (!universitiesEndorsementRows.length && !newUniversitiesEndorsementRows.length) return;
        setNewUniversitiesEndorsementRows(mapRows(universitiesEndorsementRows));
        // eslint-disable-next-line
    }, [universitiesEndorsementRows]);
    useEffect(() => {
        if (!HAUniversitiesEndorsementRows.length && !newHAUniversitiesEndorsementRows.length) return;
        setNewHAUniversitiesEndorsementRows(mapRows(HAUniversitiesEndorsementRows));
        // eslint-disable-next-line
    }, [HAUniversitiesEndorsementRows]);

    const declareStudentDefaultFormList = {
        role: {
            value: '',
            label: 'Role',
            name: 'role',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        title: {
            value: '',
            label: 'Title',
            name: 'title',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        name: {
            value: '',
            label: 'Name',
            name: 'name',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        position: {
            value: '',
            label: 'Position',
            name: 'position',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        responsibility: {
            value: '',
            label: 'Responsibility for Clinical oversight',
            name: 'responsibility',
            type: 'select',
            operators: [
                { key: 'Yes', label: 'Yes' },
                { key: 'No', label: 'No' },
            ],
            validators: ['isRequired'],
        },
        signDate: {
            value: null,
            label: 'Date',
            name: 'signDate',
            type: 'date',
        },
    };
    const declareStudentColumns = [
        { field: 'role', headerName: 'Role', width: 150 },
        { field: 'title', headerName: 'Title', width: 200 },
        { field: 'name', headerName: 'Name', width: 140 },
        { field: 'position', headerName: 'Position', width: 200 },
        { field: 'responsibility', headerName: 'Responsibility for Clinical oversight', width: 140 },
        {
            field: 'signature',
            headerName: 'Signature',
            width: 220,
            valueGetter: () => '',
        },
        {
            field: 'signDate',
            headerName: 'Date',
            width: 200,
            valueGetter: (params) => {
                let date = params.getValue('signDate');
                date = date ? getTimeWithTimeZone(date).format('YYYY-MM-DD') : '-';
                return date;
            },
        },
    ];

    const declareInvDefaultFormList = {
        role: {
            value: '',
            label: 'Role',
            name: 'role',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
            disabled: true,
        },
        title: {
            value: '',
            label: 'Title',
            name: 'title',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        name: {
            value: '',
            label: 'Name',
            name: 'name',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 512 /** first name (255) + last name (255) + space */,
            isTrim: true,
        },
        position: {
            value: '',
            label: 'Position',
            name: 'position',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        responsibility: {
            value: '',
            label: 'Responsibility for Clinical oversight',
            name: 'responsibility',
            type: 'select',
            operators: [
                { key: 'Yes', label: 'Yes' },
                { key: 'No', label: 'No' },
            ],
            validators: ['isRequired'],
        },
        signDate: {
            value: null,
            label: 'Date',
            name: 'signDate',
            type: 'date',
        },
    };
    const declareInvColumns = [
        { field: 'role', headerName: 'Role', width: 150, disableItemSort: true },
        { field: 'title', headerName: 'Title', width: 200, disableItemSort: true },
        { field: 'name', headerName: 'Name', width: 140, disableItemSort: true },
        { field: 'position', headerName: 'Position', width: 200, disableItemSort: true },
        {
            field: 'responsibility',
            headerName: 'Responsibility for Clinical oversight',
            width: 140,
            disableItemSort: true,
        },
        {
            field: 'signature',
            headerName: 'Signature',
            width: 220,

            valueGetter: () => '',
            disableItemSort: true,
        },
        {
            field: 'signDate',
            headerName: 'Date',
            width: 200,
            disableItemSort: true,
            valueGetter: (params) => {
                let date = params.getValue('signDate');
                date = date ? getTimeWithTimeZone(date).format('YYYY-MM-DD') : '-';
                return date;
            },
        },
    ];

    const HAEndorsementDefaultFormList = {
        title: {
            value: '',
            label: 'Title',
            name: 'title',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        name: {
            value: '',
            label: 'Name',
            name: 'name',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        position: {
            value: '',
            label: 'Position',
            name: 'position',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        department: {
            value: '',
            label: 'Department',
            name: 'department',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        hospitalCode: {
            value: '',
            label: 'Hospital',
            name: 'hospitalCode',
            type: 'hospitalOrInstitution',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            freeSolo: true,
        },
        signDate: {
            value: null,
            label: 'Date',
            name: 'signDate',
            type: 'date',
        },
    };
    const HAEndorsementColumns = [
        { field: 'title', headerName: 'Title', width: 200 },
        { field: 'name', headerName: 'Name', width: 200 },
        { field: 'position', headerName: 'Position', width: 200 },
        { field: 'department', headerName: 'Department', width: 200 },
        {
            field: 'hospitalCode',
            headerName: 'Hospital',
            width: 200,
            valueGetter: (params) => {
                const value = params.getValue('hospitalCode');
                return getHospitalItem(value)?.hospitalName ?? value ?? '';
            },
        },
        { field: 'signature', headerName: 'Signature', width: 220 },
        {
            field: 'signDate',
            headerName: 'Date',
            width: 100,
            valueGetter: (params) => {
                let date = params.getValue('signDate');
                date = date ? getTimeWithTimeZone(date).format('YYYY-MM-DD') : '-';
                return date;
            },
        },
    ];

    const universitiesEndorsementDefaultFormList = {
        title: {
            value: '',
            label: 'Title',
            name: 'title',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        name: {
            value: '',
            label: 'Name',
            name: 'name',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        position: {
            value: '',
            label: 'Position',
            name: 'position',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        department: {
            value: '',
            label: 'Department',
            name: 'department',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        hospitalCode: {
            value: '',
            label: 'Institution',
            name: 'hospitalCode',
            type: 'hospitalOrInstitution',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            freeSolo: true,
        },
        signDate: {
            value: null,
            label: 'Date',
            name: 'signDate',
            type: 'date',
        },
    };
    const universitiesEndorsementColumns = [
        { field: 'title', headerName: 'Title', width: 200 },
        { field: 'name', headerName: 'Name', width: 200 },
        { field: 'position', headerName: 'Position', width: 200 },
        { field: 'department', headerName: 'Department', width: 200 },
        {
            field: 'hospitalCode',
            headerName: 'Institution',
            width: 200,
            valueGetter: (params) => {
                const value = params.getValue('hospitalCode');
                return getHospitalItem(value)?.hospitalName ?? value ?? '';
            },
        },
        { field: 'signature', headerName: 'Signature', width: 220 },
        {
            field: 'signDate',
            headerName: 'Date',
            width: 100,
            valueGetter: (params) => {
                let date = params.getValue('signDate');
                date = date ? getTimeWithTimeZone(date).format('YYYY-MM-DD') : '-';
                return date;
            },
        },
    ];

    const HAUniversitiesEndorsementDefaultFormList = {
        title: {
            value: '',
            label: 'Title',
            name: 'title',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        name: {
            value: '',
            label: 'Name',
            name: 'name',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        position: {
            value: '',
            label: 'Position',
            name: 'position',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        department: {
            value: '',
            label: 'Department',
            name: 'department',
            type: 'input',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            isTrim: true,
        },
        hospitalCode: {
            value: '',
            label: 'Hospital',
            name: 'hospitalCode',
            type: 'hospitalOrInstitution',
            validators: ['isRequired', 'disableChinese'],
            maxLength: 255,
            freeSolo: true,
        },
        signDate: {
            value: null,
            label: 'Date',
            name: 'signDate',
            type: 'date',
        },
    };
    const HAUniversitiesEndorsementColumns = [
        { field: 'title', headerName: 'Title', width: 200 },
        { field: 'name', headerName: 'Name', width: 200 },
        { field: 'position', headerName: 'Position', width: 200 },
        { field: 'department', headerName: 'Department', width: 200 },
        {
            field: 'hospitalCode',
            headerName: 'Hospital',
            width: 200,
            valueGetter: (params) => {
                const value = params.getValue('hospitalCode');
                return getHospitalItem(value)?.hospitalName ?? value ?? '';
            },
        },
        { field: 'signature', headerName: 'Signature', width: 220 },
        {
            field: 'signDate',
            headerName: 'Date',
            width: 100,
            valueGetter: (params) => {
                let date = params.getValue('signDate');
                date = date ? getTimeWithTimeZone(date).format('YYYY-MM-DD') : '-';
                return date;
            },
        },
    ];

    const setRows = (key, rows) => {
        let data = { id: siteInfoId };
        const newRows = rows.map((item) => {
            if (item.siteInfo === undefined) {
                item.siteInfo = data;
            }
            return item;
        });
        dispatch({
            type: SET_DECLARATION_AND_ENDORSEMENT,
            payload: {
                [key]: newRows,
            },
        });
    };

    const formData = {
        declareStudent: {
            popupTitle: 'Declaration by Principal Investigator and other Investigator(s)',
            defaultFormList: declareStudentDefaultFormList,
            columns: declareStudentColumns,
            rows: newDeclareStudentRows,
            setRows: (rows) => setRows('declareStudentRows', rows),
        },
        declareInv: {
            popupTitle: 'Declaration by Principal Investigator and other Investigator(s)',
            defaultFormList: declareInvDefaultFormList,
            columns: declareInvColumns,
            rows: newDeclareInvRows,
            setRows: (rows) => setRows('declareInvRows', rows),
        },
        H: {
            popupTitle: 'Endorsement by COS or Authorised Representative of HA',
            defaultFormList: HAEndorsementDefaultFormList,
            columns: HAEndorsementColumns,
            rows: newHAEndorsementRows,
            setRows: (rows) => setRows('HAEndorsementRows', rows),
        },
        U: {
            popupTitle: 'Endorsement by Head of Department of the Universities',
            defaultFormList: universitiesEndorsementDefaultFormList,
            columns: universitiesEndorsementColumns,
            rows: newUniversitiesEndorsementRows,
            setRows: (rows) => setRows('universitiesEndorsementRows', rows),
        },
        C: {
            popupTitle: 'Endorsement by COS(s) or Head(s) of the Collaborating Department(s) in HA or in Universities',
            defaultFormList: HAUniversitiesEndorsementDefaultFormList,
            columns: HAUniversitiesEndorsementColumns,
            rows: newHAUniversitiesEndorsementRows,
            setRows: (rows) => setRows('HAUniversitiesEndorsementRows', rows),
        },
    };
    const initFormData = useRef({
        declareStudent: {
            rows: [],
            setRows: (rows) => setRows('declareStudentRows', rows),
        },
        declareInv: {
            rows: [],
            setRows: (rows) => setRows('declareInvRows', rows),
        },
        H: {
            rows: [],
            setRows: (rows) => setRows('HAEndorsementRows', rows),
        },
        U: {
            rows: [],
            setRows: (rows) => setRows('universitiesEndorsementRows', rows),
        },
        C: {
            rows: [],
            setRows: (rows) => setRows('HAUniversitiesEndorsementRows', rows),
        },
    });

    const declareInvDefaultRow = {
        role: '',
        title: '',
        name: '',
        position: '',
        responsibility: '',
        signDate: null,
    };

    const declareStudentDefaultRow = {
        role: '',
        title: '',
        name: '',
        position: '',
        responsibility: '',
        signDate: null,
    };

    const loadData = () => {
        /** Endorsement */
        if (declareList.length) {
            /** clear old data */
            initFormData.current.H.rows = [];
            initFormData.current.U.rows = [];
            initFormData.current.C.rows = [];

            /** set new data */
            for (let i of declareList) {
                // if (i.siteInfo.id === siteInfoId) {
                initFormData.current[i.endorse].rows.push({
                    ...i,
                    existInDB: true,
                });
                // };
            }
            /** set rows */
            const list = JSON.parse(JSON.stringify(initFormData.current));
            for (let i in list) {
                const item = list[i];
                if (item.rows.length) {
                    const rows = initFormData.current[i].rows;
                    initFormData.current[i].setRows(rows);
                } else {
                    initFormData.current[i].setRows([]);
                }
            }
        } else {
            initFormData.current.H.setRows([]);
            initFormData.current.U.setRows([]);
            initFormData.current.C.setRows([]);
        }

        /** Declaration investigator declare normal List */
        const copyDeclareInvList = [...declareInvList];
        if (removeRequestCoiIds.length) {
            /** delete declareInvList's row if coi table had deleted */
            for (let i = 0; i <= copyDeclareInvList.length; i++) {
                if (removeRequestCoiIds.includes(copyDeclareInvList[i]?.id)) {
                    copyDeclareInvList.splice(i, 1);
                }
            }
        }

        if (copyDeclareInvList.length) {
            /** clear old data */
            initFormData.current.declareInv.rows = [];

            /** set new data */
            for (let i of copyDeclareInvList) {
                // if (i.siteInfo.id === siteInfoId) {
                initFormData.current.declareInv.rows.push({
                    ...i,
                    existInDB: true,
                });
                // };
            }

            /** set rows */
            let rows = initFormData.current.declareInv.rows;
            initFormData.current.declareInv.setRows(rows);
        } else {
            initFormData.current.declareInv.setRows([]);
        }

        /** Declaration investigator declare Student List */
        if (declareStudentList.length) {
            /** clear old data */
            initFormData.current.declareStudent.rows = [];

            /** set new data */
            for (let i of declareStudentList) {
                initFormData.current.declareStudent.rows.push({
                    ...i,
                    existInDB: true,
                });
            }

            /** set rows */
            let rows = initFormData.current.declareStudent.rows;
            initFormData.current.declareStudent.setRows(rows);
        } else {
            initFormData.current.declareStudent.setRows([]);
        }
    };

    // const remoteDataDeclare = useSelector((state) => state.applicationDetail?.[formId]?.declare);
    // const previousDataDeclare = usePrevious(remoteDataDeclare);
    // const remoteDataDeclareInv = useSelector((state) => state.applicationDetail?.[formId]?.declareInv);
    // const previousDataDeclareInv = usePrevious(remoteDataDeclareInv);
    // const remoteDataDeclareStudent = useSelector((state) => state.applicationDetail?.[formId]?.declareStudent);
    // const previousDataDeclareStudent = usePrevious(remoteDataDeclareStudent);
    // // update row when remote data update
    // useEffect(() => {
    //     if (!isEqual(previousDataDeclare, remoteDataDeclare) ||
    //         !isEqual(previousDataDeclareInv, remoteDataDeclareInv) ||
    //         !isEqual(previousDataDeclareStudent, remoteDataDeclareStudent)
    //     ) {
    //         console.log(1111222)
    //         loadData();
    //     }
    //     // eslint-disable-next-line react-hooks/exhaustive-deps
    // }, [remoteDataDeclare, remoteDataDeclareInv, remoteDataDeclareStudent]);

    useEffect(() => {
        if (declareStudentRows.length) {
            setNewDeclareStudentRows(mapRows(declareStudentRows));
        }
        if (declareInvRows.length) {
            setNewDeclareInvRows(mapRows(declareInvRows));
        }
        if (HAEndorsementRows) {
            setNewHAEndorsementRows(mapRows(HAEndorsementRows));
        }
        if (universitiesEndorsementRows) {
            setNewUniversitiesEndorsementRows(mapRows(universitiesEndorsementRows));
        }
        if (HAUniversitiesEndorsementRows) {
            setNewHAUniversitiesEndorsementRows(mapRows(HAUniversitiesEndorsementRows));
        }
        // eslint-disable-next-line
    }, [siteInfoId]);

    return {
        declareStudentDefaultFormList,
        declareStudentColumns,
        declareStudentRows: newDeclareStudentRows,
        setDeclareStudentRows: (rows) => setRows('declareStudentRows', rows),
        declareInvDefaultFormList,
        declareInvColumns,
        declareInvRows: newDeclareInvRows,
        setDeclareInvRows: (rows) => setRows('declareInvRows', rows),
        HAEndorsementDefaultFormList,
        HAEndorsementColumns,
        HAEndorsementRows: newHAEndorsementRows,
        setHAEndorsementRows: (rows) => setRows('HAEndorsementRows', rows),
        universitiesEndorsementDefaultFormList,
        universitiesEndorsementColumns,
        universitiesEndorsementRows: newUniversitiesEndorsementRows,
        setUniversitiesEndorsementRows: (rows) => setRows('universitiesEndorsementRows', rows),
        HAUniversitiesEndorsementDefaultFormList,
        HAUniversitiesEndorsementColumns,
        HAUniversitiesEndorsementRows: newHAUniversitiesEndorsementRows,
        setHAUniversitiesEndorsementRows: (rows) => setRows('HAUniversitiesEndorsementRows', rows),
        formData,
        declareInvDefaultRow,
        declareStudentDefaultRow,
        loadData,
    };
};

export default useDeclarationAndEndorsementData;
